module.exports = __webpack_public_path__ + "static/media/mask.64282a6d.png";